// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/work-item-list-schema',
  type: 'object',
  required: ['id'],
  nullable: true,
  properties: {
    id: {
      type: 'integer',
    },
    title: {
      type: 'string',
      nullable: true,
    },
    type: {
      enum: [
        0,
        1,
        2,
        3,
        4,
      ],
    },
    status: {
      enum: [
        0,
        1,
        2,
        3,
        4,
      ],
    },
    sprintId: {
      type: 'string',
      format: 'uuid',
    },
    sprintName: {
      type: 'string',
      nullable: true,
    },
    parentId: {
      type: 'integer',
      nullable: true,
    },
    parentTitle: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
